import { render, staticRenderFns } from "./OauthorOIDCAssociation.vue?vue&type=template&id=7bd881f1&scoped=true&"
import script from "./OauthorOIDCAssociation.vue?vue&type=script&lang=ts&"
export * from "./OauthorOIDCAssociation.vue?vue&type=script&lang=ts&"
import style0 from "./OauthorOIDCAssociation.vue?vue&type=style&index=0&id=7bd881f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd881f1",
  null
  
)

export default component.exports